import React, {Component} from "react"
import "bootstrap/dist/css/bootstrap.min.css"
import "./Header.css"
import {withRouter} from "react-router-dom"
class Header extends Component{
    state = {
        headerlogowhite : "./logoimage_white.png",
        headerlogo : "./logoimage.png"
    }
    componentDidMount(){
        window.addEventListener("scroll", () => {
            if(window.scrollY > 200){
                document.getElementById("header").style.backgroundColor = "rgba(33,150,243 ,1)"
            }else{
                document.getElementById("header").style.backgroundColor = "rgba(33,150,243 ,0)"
            }
        })
    }
    render(){
        return <header id="header">
            <div id="horizontal_header" className="c_header_horizontal row">
                <div className="c_header_logo_container col-md-3">
                    <img alt="Arth"className="c_header_logo" src={this.state.headerlogowhite}/>
                </div>
                <div className="c_header_tab_elements_container col-md-9">
                    {/* <div className="c_header_tab_element">Home</div>
                    <div className="c_header_tab_element">About</div> */}
                </div>
            </div>
            <div id="vertical_header" className="c_header_vertical">
                {/* <div className="c_menubutton">&#9776;</div> */}
                <img alt="Arth"className="c_header_logo_vertical" src={this.state.headerlogo}/>
            </div>
        </header>
    }
}

export default withRouter(Header)